import { render } from "./IndividualAdd.vue?vue&type=template&id=466c86b2&scoped=true"
import script from "./IndividualAdd.vue?vue&type=script&lang=js"
export * from "./IndividualAdd.vue?vue&type=script&lang=js"

import "./IndividualAdd.vue?vue&type=style&index=0&id=466c86b2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-466c86b2"

export default script